<div class="teams">
  <!-- `UsersRound` is registered by plan 50-09; until then the icon slot renders blank.
       Reusing `Users` would collide with the Settings > Users nav anchor. -->
  <ui-page-header [title]="'settings.teams' | translate" [lucideIcon]="'UsersRound'">
    <ui-button
      type="primary"
      [label]="('settings.team' | translate | uppercase)"
      icon="plus-cc"
      iconSize="large"
      iconPosition="start"
      (click)="editTeam()"></ui-button>
  </ui-page-header>

  <!-- Toolbar — same shape as the users page: search on the left, count on the right. -->
  <div class="teams__toolbar">
    <ui-form-field
      [formControl]="searchControl"
      [suffixIcon]="'search_icon'"
      [placeholder]="'settings.search_team_name' | translate">
    </ui-form-field>

    <ng-container *ngIf="filteredTeams$ | async as filtered">
      <span class="teams__result-count">{{ filtered.length }} {{ 'settings.teams' | translate | lowercase }}</span>
    </ng-container>
  </div>

  <div class="teams__card">
    <div class="teams__table-wrapper">
      <table class="teams__table">
        <thead>
          <tr class="teams__table-head">
            <th class="teams__col--monogram-head"></th>
            <th>
              <button class="teams__sort-button" (click)="onSort('name')" type="button">
                <span>{{ 'settings.team_name' | translate }}</span>
                <span class="teams__sort-arrows">
                  <span class="teams__sort-arrow teams__sort-arrow--up" [class.teams__sort-arrow--active]="sortField === 'name' && sortMode === 'asc'"></span>
                  <span class="teams__sort-arrow teams__sort-arrow--down" [class.teams__sort-arrow--active]="sortField === 'name' && sortMode === 'desc'"></span>
                </span>
              </button>
            </th>
            <th>
              <button class="teams__sort-button" (click)="onSort('member_count')" type="button">
                <span>{{ 'settings.users' | translate }}</span>
                <span class="teams__sort-arrows">
                  <span class="teams__sort-arrow teams__sort-arrow--up" [class.teams__sort-arrow--active]="sortField === 'member_count' && sortMode === 'asc'"></span>
                  <span class="teams__sort-arrow teams__sort-arrow--down" [class.teams__sort-arrow--active]="sortField === 'member_count' && sortMode === 'desc'"></span>
                </span>
              </button>
            </th>
            <th>
              <button class="teams__sort-button" (click)="onSort('last_edited')" type="button">
                <span>{{ 'settings.last_edited' | translate }}</span>
                <span class="teams__sort-arrows">
                  <span class="teams__sort-arrow teams__sort-arrow--up" [class.teams__sort-arrow--active]="sortField === 'last_edited' && sortMode === 'asc'"></span>
                  <span class="teams__sort-arrow teams__sort-arrow--down" [class.teams__sort-arrow--active]="sortField === 'last_edited' && sortMode === 'desc'"></span>
                </span>
              </button>
            </th>
            <th class="teams__col--actions-head"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let team of filteredTeams$ | async; trackBy: trackByTeamId">
            <tr
              class="teams__row"
              [class.teams__row--selected]="selectedTeam?.id === team.id"
              (click)="selectTeam(team)">
              <!-- Monogram — its own leading column, like the users page avatar. -->
              <td class="teams__col--monogram">
                <span class="teams__name-chip">{{ getTeamInitials(team) }}</span>
              </td>

              <td class="teams__col--team">
                <span class="teams__name">{{ team.name }}</span>
                <span class="teams__description">{{ team.description || emptyStateValue }}</span>
              </td>

              <td class="teams__col--members">
                <div class="teams__members">
                  <div class="teams__members-avatars" *ngIf="getMemberCount(team)">
                    <div
                      class="teams__members-avatar"
                      *ngFor="let member of team.members | slice:0:visibleMemberAvatars; trackBy: trackByMemberId">
                      <span
                        class="teams__members-avatar-initials"
                        [style.background]="getUserColor(member)"
                        [matTooltip]="member.name || ('user.user' | translate)">
                        {{ getUserInitials(member) }}
                      </span>
                    </div>
                  </div>
                  <!-- Figma 23521:4761 shows the bare count beside the avatar stack, with no
                       "users" label. The column header already says USERS. -->
                  <span class="teams__members-count">{{ getMemberCount(team) }}</span>
                </div>
              </td>

              <td class="teams__col--last-edited">
                <span class="teams__last-edited">{{ formatLastEdited(team.last_edited) || emptyStateValue }}</span>
              </td>

              <td class="teams__col--actions" (click)="$event.stopPropagation()">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="teamMenu"
                  class="teams__actions-btn"
                  [attr.aria-label]="'common.actions' | translate">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #teamMenu="matMenu" xPosition="before" panelClass="ui-action-menu">
                  <button mat-menu-item class="ui-action-menu-item" (click)="editTeam(team)">
                    <span class="ui-action-menu-item__icon">
                      <ui-svg-icon svgIcon="pen-cc"></ui-svg-icon>
                    </span>
                    <span class="ui-action-menu-item__label">{{ 'common.edit' | translate }}</span>
                  </button>
                  <button
                    mat-menu-item
                    class="ui-action-menu-item ui-action-menu-item--danger"
                    (click)="deleteTeam(team)">
                    <span class="ui-action-menu-item__icon">
                      <ui-svg-icon svgIcon="trash-cc"></ui-svg-icon>
                    </span>
                    <span class="ui-action-menu-item__label">{{ 'common.delete' | translate }}</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <!-- The backend answers an empty tenant with 200 + data: []; without this the page
           would render nothing but a header row. Gated on the loader so it does not flash
           before the first response lands. Also covers a search that matched nothing. -->
      <div class="teams__empty" *ngIf="!(filteredTeams$ | async)?.length && (loading$ | async) === false">
        {{ (hasSearchTerm ? 'settings.no_teams_found' : 'settings.no_teams') | translate }}
      </div>
    </div>
  </div>
</div>
